import React from 'react';
import { Award, Users, Star, Wheat } from 'lucide-react';
import { bakeryInfo, images } from '../data/mock';

export const AboutSection = () => {
  const highlights = [
    {
      icon: Award,
      value: '75',
      label: 'Jahre Tradition'
    },
    {
      icon: Users,
      value: '3',
      label: 'Generationen'
    },
    {
      icon: Wheat,
      value: '100%',
      label: 'Natürlich'
    }
  ];

  return (
    <section id="ueber-uns" className="py-16 sm:py-24 lg:py-32 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl sm:shadow-2xl">
              <img
                src={images.elegantPastries}
                alt="Feinste Backwaren"
                className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e1919]/40 to-transparent" />
            </div>
            
            {/* Floating Badge - Hidden on very small screens */}
            <a 
              href="https://www.meinbezirk.at/rudolfsheim-fuenfhaus/c-lokales/die-konditorei-rieppel-legt-wert-auf-tradition_a6905472"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:block absolute -bottom-4 sm:-bottom-6 -right-2 sm:-right-6 bg-[#61525a] text-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-xl hover:bg-[#4a3f45] transition-all duration-300 hover:-translate-y-1"
            >
              <p className="text-xs sm:text-sm text-white/70">Bekannt aus</p>
              <p className="text-base sm:text-lg font-bold">{bakeryInfo.knownFrom}</p>
              <p className="text-xs text-white/50 mt-1">Artikel lesen →</p>
            </a>

            {/* Mobile Badge - Below Image */}
            <a 
              href="https://www.meinbezirk.at/rudolfsheim-fuenfhaus/c-lokales/die-konditorei-rieppel-legt-wert-auf-tradition_a6905472"
              target="_blank"
              rel="noopener noreferrer"
              className="sm:hidden flex items-center justify-between bg-[#61525a] text-white p-4 rounded-xl mt-4"
            >
              <div>
                <p className="text-xs text-white/70">Bekannt aus</p>
                <p className="text-base font-bold">{bakeryInfo.knownFrom}</p>
              </div>
              <span className="text-white/70">→</span>
            </a>

            {/* Decorative Element */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#fad24b]/20 rounded-full blur-2xl hidden sm:block" />
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <span className="inline-block text-[#61525a] font-medium text-xs sm:text-sm tracking-wider uppercase mb-3 sm:mb-4">
              Unsere Geschichte
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e1919] mb-4 sm:mb-6 leading-tight">
              Die Naturbackstube<br />
              <span className="text-[#61525a]">seit 3 Generationen</span>
            </h2>
            
            {/* Quote Block */}
            <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 mb-4 sm:mb-6 border-l-4 border-[#fad24b] shadow-sm">
              <p className="text-[#1e1919] text-base sm:text-lg italic leading-relaxed">
                „Hier wird noch alles per Hand und ohne künstliche Zusätze oder 
                Fertigmischungen gebacken – so wie ich es schon von meinem 
                Großvater und Vater lernte."
              </p>
              <p className="text-[#61525a] font-semibold mt-2 sm:mt-3 text-sm sm:text-base">
                — Stefan Rieppel, Bäckermeister
              </p>
            </div>

            <p className="text-[#736c64] text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
              Willkommen in unserer Naturbackstube im Herzen des 15. Bezirks. 
              Bäckermeister Stefan Rieppel führt die Familientradition fort und 
              verwöhnt Sie täglich mit ehrlichem Handwerk: frisches Brot, feine 
              Torten und klassisches Wiener Gebäck – alles 100% natürlich.
            </p>
            <p className="text-[#736c64] text-base sm:text-lg leading-relaxed mb-4 sm:mb-6 hidden sm:block">
              „Wir sind Bäckerei, Konditorei und Café in einem", erzählt Stefan Rieppel. 
              Bereits kurz nach Mitternacht beginnt die Herstellung der duftenden Backwaren. 
              Unser Team von 12 Mitarbeitern beliefert auch Schulen, Kindergärten und Seniorenheime.
            </p>
            <p className="text-[#736c64] text-base sm:text-lg leading-relaxed mb-6 sm:mb-10 hidden sm:block">
              Wir sind stolz darauf, auch spezielle Backwaren für Diabetiker anzubieten – 
              damit jeder unsere Köstlichkeiten genießen kann. Im Sommer laden wir Sie 
              herzlich in unseren Schanigarten mit 20 Plätzen ein.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-3 gap-3 sm:gap-6">
              {highlights.map((item, index) => (
                <div key={index} className="text-center p-3 sm:p-4 rounded-xl sm:rounded-2xl bg-white shadow-sm">
                  <item.icon className="w-6 sm:w-8 h-6 sm:h-8 text-[#61525a] mx-auto mb-1 sm:mb-2" />
                  <p className="text-2xl sm:text-3xl font-bold text-[#1e1919]">{item.value}</p>
                  <p className="text-xs sm:text-sm text-[#736c64]">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
